import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle,
} from 'components/common/Dialog';

import { submit, isSubmitting } from 'redux-form';

import Button from 'components/common/Button';

import PasswordChangeForm from './PasswordChangeForm';

const styles = () => ({
  form: {
    padding: '35px 105px',
  },
});

const PasswordChangeDialog = ({
  open,
  onClose,
  actions,
  submitting,
  initialValues,
  classes,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="sm"
  >
    <DialogTitle>
      <Typography
        variant="title"
        color="secondary"
        align="center"
      >
        Password Change
      </Typography>
    </DialogTitle>
    <DialogContent>
      <PasswordChangeForm
        className={classes.form}
        form="profilePasswordChange"
        onSubmitSuccess={onClose}
        {...initialValues ? { initialValues } : {}}
      />
    </DialogContent>
    <DialogActions>
      <Button
        onClick={onClose}
        variant="raised"
      >
        Cancel
      </Button>
      <Button
        onClick={() => actions.submit('profilePasswordChange')}
        variant="raised"
        color="primary"
        disabled={submitting}
      >
        Change Password
      </Button>
    </DialogActions>
  </Dialog>
);

PasswordChangeDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  submitting: PropTypes.bool.isRequired,
  initialValues: PropTypes.shape({
    ID: PropTypes.number,
  }),
  actions: PropTypes.shape({
    submit: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    form: PropTypes.string.isRequired,
  }).isRequired,
};

PasswordChangeDialog.defaultProps = {
  open: false,
  initialValues: null,
  onClose: () => {},
};

const mapStateToProps = store => ({
  submitting: isSubmitting('profilePasswordChange')(store),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ submit }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(PasswordChangeDialog),
);



// WEBPACK FOOTER //
// ./src/components/account/PasswordChangeDialog/PasswordChangeDialog.js